<template>
  <v-container class="no-margins">
    <div class="title-icon">
      <h1 class>{{ $t('ebook.period') }}</h1>
      <v-btn icon :href="links.ebook.apprenticeInfo" target="_blank">
        <v-icon>$sl-question</v-icon>
      </v-btn>
    </div>
    <v-row>
      <v-col cols="4">
        <v-btn
          block
          min-width="90"
          @click="dateClick(0)"
          class="center btn-label application"
        >{{ $t('ebook.today') }}</v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn
          block
          min-width="90"
          @click="dateClick(-1)"
          class="center btn-label application"
        >{{ $t('ebook.yesterday') }}</v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn
          block
          min-width="90"
          @click="dateClick(-2)"
          class="center btn-label application"
        >{{ $t('ebook.beforeYesterday') }}</v-btn>
      </v-col>
    </v-row>
    
    <v-row>
      <v-col cols="6">
        <v-menu
          v-model="calendar"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              outlined
              v-model="startDate"
              :label="$t('labels.from')"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="sv"
            v-model="startDate"
            show-week
            first-day-of-week="1"
            :rules="[rules.required]"
            @input="calendar = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="6">
        <v-menu
          v-model="calendarTo"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field outlined v-model="endDate" :label="$t('labels.to')" readonly v-on="on"></v-text-field>
          </template>
          <v-date-picker
            locale="sv"
            v-model="endDate"
            show-week
            first-day-of-week="1"
            :min="startDate"
            :rules="[rules.required]"
            @input="calendarTo = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <NextButton
      class="mt-0"
      :isDisabled="startDate=='' || endDate=='' || isImitatingUser()"
      @click="next"
    >{{ $t('labels.workplace') }}</NextButton>
    <BottomNav @clicked="goBack" />
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import API from '@/services/api.js'
// new steps

import NextButton from '@/components/Common/NextButton'
import BottomNav from '@/components/Application/BottomNav'
import {RulesMixin} from '@/components/mixins'
import ActionButton from '@/components/Common/ActionButton'

const SugarDate = require('sugar/date')

// @group Ebook
// Styled EbookInstructor component
export default {
  name: 'EbookInstructor',

  mixins: [RulesMixin],

  props: {
    //has current report
    currentReport: Object
  },

  components: {
    BottomNav,
    NextButton,
    ActionButton
  },

  data: () => ({
    links: require('../../../lib/external-links.json'),
    startDate: '',
    calendar: false,
    endDate: '',
    report: {},
    calendarTo: false
  }),

  created() {
    this.init()
  },

  watch: {
    currentReport(val) {
      this.init()
    }
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isApprentice', 'isInstructor', 'isImitatingUser'])
  },

  methods: {
    goBack(){
      const name = this.$route.params.returnUrl || 'EbookReportElement';
      this.$nextTick(()=>{
        this.$router.push({name, params: {id: this.$route.params.id} })
      })
    },

    init() {      
      if (!(this.currentReport || this.currentReport.id)) return
      else {
        this.report = this.currentReport
        if (this.currentReport && this.currentReport.fromDate) {
          this.startDate = this.dateFormat(this.currentReport.fromDate)
        } else {
          this.startDate = new Date().toISOString().substr(0, 10)
        }

        if (this.currentReport && this.currentReport.toDate) {
          this.endDate = this.dateFormat(this.currentReport.toDate)
        } else {
          this.endDate = new Date().toISOString().substr(0, 10)
        }
      }
    },
    dateClick(addDays) {
      var date = new Date()
      this.startDate = SugarDate.Date(date)
        .addDays(addDays)
        .format('{yyyy}-{MM}-{dd}').raw
      this.endDate = this.startDate
    },
    dateFormat(date) {
      if (date && date.length > 10) return date.substring(0, 10)
      else {
        return ''
      }
    },
    goback() {
      // Fire go back
      // @arg The argument is a object representing report
      this.$emit('goto', {report: this.report, goto: 'instructor'})
    },
    /**
     * @vuese
     * Used to go to next step
     */
    next() {
      if (this.startDate == '' || this.endDate == '') return
      else if (this.endDate < this.startDate) {
        this.$events.fire('showError', this.$t('ebook.show-error-date'))
        return
      }
      let rep = this.report
      rep.fromDate = this.startDate
      rep.toDate = this.endDate
      if (this.report && this.report.id && this.report.id > 0 && this.report.bookId && this.report.bookId > 0) {
        API.updateReport(this.report.bookId, this.report.id, {
          data: rep
        })
          .then(response => {
            this.report.toDate = response.data.toDate
            this.report.fromDate = response.data.fromDate
            const params = {report: this.report, goto: 'workplace'}
             // Fire goto
              // @arg The argument is a object representing report
            this.$emit('goto', params)
          })
          .catch(error => {
            console.log('Error: ', error)
            this.$events.fire('showError', this.$t('error.create-report-error'))
          })
       
      } else {
        API.createReport({
          data: {
            bookId: Number(this.$route.params.id),
            fromDate: this.startDate,
            toDate: this.endDate
          }
        })
          .then(response => {
            this.report = response.data
            this.report.toDate = response.data.toDate
            this.report.fromDate = response.data.fromDate

            const params = {report: response.data, goto: 'workplace'}
             // Fire goto
              // @arg The argument is a object representing report
            this.$emit('goto', params)
          })
          .catch(error => {
            console.log('Error: ', error)
            this.$events.fire('showError', this.$t('error.create-report-error'))
          })
      }
    }
  }
}
</script>

<style lang="scss">
</style>
